import { useEffect, useState } from "react";
import { Crown, Trophy } from "lucide-react";
import { api } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { periodLabel } from "./BranchTargetPopup";

const MEDAL = ["text-amber-400", "text-slate-300", "text-amber-700"];

export function BranchLeaderboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/branch-requests/leaderboard").then((r) => setData(r.data)).catch(() => setData({ rows: [] })); }, []);
  if (!data) return null;
  return (
    <Card className="bg-card border-border overflow-hidden" data-testid="branch-leaderboard">
      <div className="h-1 bg-gradient-to-r from-amber-400 via-[#F04E23] to-amber-400" />
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-heading flex items-center justify-between gap-2">
          <span className="flex items-center gap-2"><Trophy className="w-4 h-4 text-amber-400" /> Papan Peringkat Cabang Baru</span>
          <span className="text-[11px] font-mono text-muted-foreground font-normal">{periodLabel(data.period)}</span>
        </CardTitle>
        <p className="text-xs text-muted-foreground">Agen dengan cabang baru terbanyak yang disetujui bulan ini{data.target ? ` — target ${data.target} cabang` : ""}.</p>
      </CardHeader>
      <CardContent className="space-y-1.5">
        {!data.rows.length && <p className="text-xs text-muted-foreground text-center py-3" data-testid="branch-leaderboard-empty">Belum ada cabang baru disetujui bulan ini — jadilah yang pertama!</p>}
        {data.rows.map((r) => {
          const me = r.email === data.me;
          return (
            <div key={r.email} className={`flex items-center gap-3 rounded-xl px-3 py-2 border ${me ? "border-sky-500/60 bg-sky-500/10" : "border-border bg-accent/30"}`} data-testid={`leaderboard-row-${r.rank}`}>
              <div className={`w-7 text-center font-heading font-bold ${MEDAL[r.rank - 1] || "text-muted-foreground"}`}>{r.rank <= 3 ? <Crown className="w-5 h-5 mx-auto" /> : `#${r.rank}`}</div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold truncate">{r.code && <span className="font-mono text-muted-foreground">[{r.code}] </span>}{r.name}{me && <span className="ml-1 text-[10px] text-sky-400 font-mono">(Anda)</span>}</div>
                <div className="text-[10px] text-muted-foreground font-mono truncate">{r.branches.join(", ")}</div>
              </div>
              <div className="text-right"><div className="text-lg font-heading font-bold leading-none" data-testid={`leaderboard-count-${r.rank}`}>{r.count}</div><div className="text-[9px] text-muted-foreground font-mono">cabang</div></div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}
